//import api_patho_opd_job_worklist from "@/api/api_patho_opd_job_worklist";
// import {  getBaseURLforBackEnd , getConfigAxios ,myTimeZone }  from '@/utils.js'
// import axios from "axios";
// import master_data from "./master_data";
// import moment from 'moment-timezone' 



export default {
    namespaced: true,

    state: {
        resultSearchOPDForGneralArr: [],
         

    },

    getters: {
    
    },

    mutations: {
         

        setResultSearchOPDForGneralArr  (state, resultSearchOPDForGneralArr) {
            state.resultSearchOPDForGneralArr = resultSearchOPDForGneralArr
        },

         



    },

    actions: {
        // fetchOPDPathoJobList({commit}) {
        //     return new Promise((resolve) => {
        //         // make the call
        //         // call setProducts mutation
        //         api_patho_opd_job_worklist.getOPDPathoJobList(opdPathoJobList => {
        //             commit('setopdPathoJobList', opdPathoJobList)
        //             resolve()
        //         })
        //     })
        // }
        // <!-- api listofdvm <br/>
        // list_of_departmentappoint  <br/> -->

    


 





   

 

        
        

        



    }
}